export function attachFilterPlucking(config, filters) {
    if (!filters || !config.ajax) return;

    if (typeof config.ajax === 'function') {
        const originalAjax = config.ajax;
        config.ajax = (d, callback, settings) => {
            Object.keys(filters).forEach((key) => {
                const selector = filters[key];
                const $el = $(selector);
                if ($el.length) d[key] = $el.val();
            });
            return originalAjax(d, callback, settings);
        };
        return;
    }

    if (typeof config.ajax === 'object') {
        const originalData = config.ajax.data;
        config.ajax.data = (d, settings) => {
            Object.keys(filters).forEach((key) => {
                const selector = filters[key];
                const $el = $(selector);
                if ($el.length) d[key] = $el.val();
            });

            if (typeof originalData === 'function') {
                return originalData(d, settings);
            }
            if (originalData && typeof originalData === 'object') {
                Object.assign(d, originalData);
            }
            return undefined;
        };
        return;
    }

    if (typeof config.ajax === 'string') {
        const url = config.ajax;
        config.ajax = {
            url,
            data: (d) => {
                Object.keys(filters).forEach((key) => {
                    const selector = filters[key];
                    const $el = $(selector);
                    if ($el.length) d[key] = $el.val();
                });
            }
        };
    }
}

export function debounce(fn, delay) {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
    };
}
